import moment from 'moment';
import diff from './diff';

// ISODate :: String
// @link: https://en.wikipedia.org/wiki/ISO_8601

// YYYY-MM-DDThh:mm:ss.sssZ :: "2017-08-16T19:49:50.940Z"
// YYYY-MM-DD               :: "2017-08-16"

// diffDay :: ISODate|String -> ISODate|String -> Number
const diffDay = (firstDate, secondDate) =>
  diff(
    'day',
    moment(firstDate).startOf('day'),
    moment(secondDate).startOf('day'),
  );

export default diffDay;
